import { render, staticRenderFns } from "./Documented.vue?vue&type=template&id=fa50906a"
import script from "./Documented.vue?vue&type=script&lang=js"
export * from "./Documented.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports